// ../Cookies.js or wherever you import it from
import React, { useEffect, useState } from 'react';

const CookieConsentBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true');
    setIsVisible(false);
  };

  const handlReject = () => {
    localStorage.setItem('cookieConsent', 'false');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div style={{ position: 'fixed', flexDirection:'column', textAlign:'center', bottom: 0, background: '#222', color: '#fff', width: 'max-content', left:'50%', transform:'translateX(-50%)', padding: '12px 24px', display: 'flex', zIndex:'9999', justifyContent: 'center', alignItems: 'center', fontSize:'13px' }}>
      <span>We use cookies to enhance your browsing experience and analyze site traffic. <br/> By continuing to use our website, you consent to our use of cookies in accordance with our <a href='PrivacyPolicy' style={{color:"#fff", textDecoration:"underline"}}>Privacy Policy</a>.</span>
      <div style={{marginTop:'6px'}}>
        <button onClick={handlReject}  style={{ padding: '8px 16px', background: '#fff', color: '#333', border: 'none', borderRadius: '0px', marginRight:'8px' }}>
            Reject
        </button>
        <button onClick={handleAccept} style={{ padding: '8px 16px', background: '#4caf50', color: '#fff', border: 'none', borderRadius: '0px' }}>
            Accept
        </button>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
